import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/Header/Header";
import Features from "../../components/Feature-section/Features";
import Newsletter from "../../components/Newsletter/Newsletter";
import Footer from "../../components/Footer/Footer";
import CategoryCourseCard from "../../components/Courses-section/Categories/CategoryCourseCard";
import HeadSection from "../../components/meta";
import { getPublishedCourses } from "../../controllers/coursesController";
import { MODEL } from "../../model";
import BannerAd from "../../components/Ads/bannerAd";

const Courses = () => {
  const [courses, setCourses] = useState([]);

  const getCoursesData = async () => {
    const FCourses = await getPublishedCourses();
    setCourses(FCourses);
  };

  useEffect(() => {
    getCoursesData();
  }, []);

  if (!courses) {
    return <h3>Loading Courses...</h3>;
  }

  return (
    <>
      <HeadSection
        title={"COURSES"}
        keywords={""}
        addPostFixTitle={true}
        largeTwitterCard={true}
        showCanonical={true}
        content={
          "Explore expert-led courses at Seed to Tree Academy. From beginner to advanced, gain skills to excel in today's fast-changing world. Start your learning journey today!"
        }
        link={`/courses`}
      />
      <Header isActive="courses" />
      <section className="courses" id="courses">
        <div>
          <div className="course__top d-flex justify-content-between align-items-center flex-wrap">
            <div className="course__top__left w-60">
              <h1>Discover & Explore Our Courses Today!</h1>
              <p>
                SEED TO TREE offers a diverse range of courses designed to
                empower individuals with knowledge and skills that matter in
                today's ever-changing world. Our courses are thoughtfully
                crafted to cater to learners of all levels, from beginners
                taking their first steps in a subject to advanced professionals
                seeking to stay at the forefront of their fields.
              </p>
            </div>
          </div>
        </div>
        <BannerAd />
        {MODEL.data.courses_categories.map((category) => {
          const categoryCourses = courses.filter(
            (course) => course.category === category
          );

          return (
            <div
              id={`${category}`}
              key={category}
              className="courses__category"
            >
              <h2>{category.toUpperCase()} Courses</h2>

              <div className="courses__category__list">
                {categoryCourses.length > 0 ? (
                  categoryCourses.map((course) => (
                    <CategoryCourseCard key={course.id} course={course} />
                  ))
                ) : (
                  <h3 className="coming-soon">Coming Soon</h3>
                )}
              </div>

              <div className="courses__bottom w-100">
                <Link to={`/courses/${category}`}>See All</Link>
              </div>
            </div>
          );
        })}
      </section>

      <Features />
      <Newsletter />
      <Footer />
    </>
  );
};

export default Courses;
